import React, { Component } from 'react';
import { get, post } from 'axios';
import { inject } from 'mobx-react';
import { Page, Image, Text, View, Document, StyleSheet, PDFViewer, Font } from '@react-pdf/renderer';

Font.register({
  family: "Roboto",
  src:
    "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf"
});

Font.register({
  family: "Keyboard",
  src: require('../../img/Keyboard.ttf')
});


// Create styles
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFF',
    fontFamily : "Keyboard"
  },
  businessHeader: {
    flexDirection: 'row'
  },
  header: {
    flexDirection: 'column',
    alignItems:'center'
  },
  image: {
    textAlign: 'center'
  },
  section: {
    flexDirection: 'column',
    marginTop: 0,
    marginRight: 10,
    marginLeft: 10,
    padding: 10,
    paddingTop:0
  },
  heading: {
    fontSize: 12+'pt',
    marginBottom: 2
  },
  subHeading: {
    fontSize: 8+'pt',
    marginBottom: 2
  },
  sub_total: {
    fontSize: 12+'pt',
    marginTop: 20,
    marginBottom: 5,
    textAlign:'right'
  },
  table: {
    display: "table",
    width: "auto",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    margin: "auto",
    flexDirection: "row"
  },
  tableRowHeading: {
    backgroundColor:'#e5e5e5',
    margin: "auto",
    flexDirection: "row"
  },
  tableColFooter1: {
    width: "70%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign:'left'
  },
  tableCol10: {
    textAlign:'left',
    width: "10%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol20: {
    width: "20%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    textAlign:'left'
  },
  tableCol30: {
    width: "30%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol50: {
    width: "50%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol15: {
    width: "15%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCol5: {
    width: "5%",
    borderStyle: "solid",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },
  tableCell: {
    textAlign:"left",
    padding: 5,
    fontSize: 8+'pt'
  },
  tableCellQuantity: {
    textAlign:"right",
    padding: 2,
    marginTop: 5,
    fontSize: 10
  },
  itemRow:{
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin:5
  },
  itemRowHeading:{
    justifyContent: 'space-between',
    flexDirection: 'row',
    margin:5,
    fontWeight:'bold',
    borderBottom: 1+'pt'
  },
  item: {
    fontSize: 10+'pt'
  }
});

class PDFBusinessHeader extends Component {
  render() {
    const { business } = this.props;
    return (
      <View style={[styles.section,{marginTop:'10px',flexDirection:'column',alignItems:'right'}]}>
        <Text style={styles.heading}>{business.name}</Text>
        <Text style={styles.subHeading}>{business.address}</Text>
        <Text style={styles.subHeading}>{business.phone_primary}</Text>
      </View>
    );
  }
}

class PDFEventHeader extends Component {
  render() {
    const { booking } = this.props;
    return (
      <View style={[styles.section,{marginTop:'10px',flexDirection:'column',justifyContent:'left'}]}>
        <Text style={styles.heading}>{booking.full_name}</Text>
        <Text style={styles.subHeading}>Event Date: {booking.event_date}</Text>
        <Text style={styles.subHeading}>Ready Time: {booking.ready_time}</Text>
        <Text style={styles.subHeading}>Ready Location: {booking.address}</Text>
        <Text style={styles.subHeading}>Proposal ID: {booking.hash_id}</Text>
      </View>
    );
  }
}


@inject('userStore')
class ModalPDF extends Component {
    constructor(props){
      super(props);
      this.state = {
        proposal:null,
        business:null,
        bk_temp:null
      }
    }

    componentDidMount(){
      post('/v2/print', {type: 'proposal', hash_id:'00dc9c56f5ca400698b249c6dcf7eccf'},{auth: {username: this.props.userStore.token}
      }).then((res) => {
        if (res.data.errors === 0){
          this.setState({
            proposal:res.data.proposal,
            business:res.data.business,
            bk_temp:res.data.bk_temp
          })
        } else {
          alert(this.data.message);
        }
      }).catch((error) => {
        alert(error);
        return error;
      });
    }

    render() {
      if (!this.state.proposal) return <div>Loading</div>;
      const { bk_temp, business, proposal } = this.state;
      return (
        <div style={{height:800+'px'}}>
          <PDFViewer width={100+'%'} height={100+'%'}>
            <Document>
              <Page size="A4" style={styles.page}>
                <PDFBusinessHeader business={business}/>
                <View style={styles.section}>
                  <View style={styles.header}>
                  <Text style={styles.heading}>{bk_temp.book_type} Proposal</Text>
                  <Text style={styles.item}>{proposal.name}</Text>
                  </View>
                </View>
                <PDFEventHeader booking={bk_temp}/>
                <View style={styles.section}>
                  <Text style={styles.heading}>Event Services</Text>
                  <View style={styles.table}>
                    <View style={styles.tableRowHeading}>
                      <View style={styles.tableCol20}>
                        <Text style={styles.tableCell}>Service Name</Text>
                      </View>
                      <View style={styles.tableCol50}>
                        <Text style={styles.tableCell}>Description</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Unit</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Quantity</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Total</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                  {proposal.service_list.map((service, service_index)=>
                    <React.Fragment key={service_index}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCol20}>
                          <Text style={styles.tableCell}>{service.name}</Text>
                        </View>
                        <View style={styles.tableCol50}>
                          <Text style={styles.tableCell}>{service.description}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>${service.price}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>{service.quantity}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>${service.total}</Text>
                        </View>
                      </View>
                    </React.Fragment>
                  )}
                  </View>
                  <Text style={styles.sub_total}>Service Total: ${proposal.service_total}</Text>
                </View>
                <View style={styles.section}>
                  <Text style={styles.heading}>Event Line Items</Text>
                  <View style={styles.table}>
                    <View style={styles.tableRowHeading}>
                      <View style={styles.tableCol20}>
                        <Text style={styles.tableCell}>Line Item Name</Text>
                      </View>
                      <View style={styles.tableCol50}>
                        <Text style={styles.tableCell}>Description</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Unit</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Quantity</Text>
                      </View>
                      <View style={styles.tableCol10}>
                        <Text style={styles.tableCell}>Total</Text>
                      </View>
                    </View>
                  </View>
                  <View style={styles.table}>
                  {proposal.lineitem_list.map((lineitem, lineitem_index)=>
                    <React.Fragment key={lineitem_index}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCol20}>
                          <Text style={styles.tableCell}>{lineitem.name}</Text>
                        </View>
                        <View style={styles.tableCol50}>
                          <Text style={styles.tableCell}>{lineitem.description}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>${lineitem.price}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>{lineitem.quantity}</Text>
                        </View>
                        <View style={styles.tableCol10}>
                          <Text style={styles.tableCell}>${lineitem.total}</Text>
                        </View>
                      </View>
                    </React.Fragment>
                  )}
                  </View>
                  <Text style={styles.sub_total}>Line Item Total: ${proposal.lineitem_total}</Text>
                </View>
              </Page>
            </Document>
          </PDFViewer>
        </div>);
    }
}

export default ModalPDF;

// <Image src={require('../../img/ttg_logo_dark.png')} style={styles.image, {width:180+'px', height:28+'px'}}/>
// <View style={styles.section}>
// {service_list.map((item, item_index)=>
//   <React.Fragment key={item_index}>
//     <Text key={item_index} style={styles.heading}>{item.account.name}</Text>
//     <View style={styles.table}>
//       <View style={styles.tableRowHeading}>
//         <View style={styles.tableCol1}>
//           <Text style={styles.tableCell}>Product Name</Text>
//         </View>
//         <View style={styles.tableCol2}>
//           <Text style={styles.tableCell}>Format</Text>
//         </View>
//         <View style={styles.tableCol3}>
//           <Text style={styles.tableCellQuantity}>Quantity</Text>
//         </View>
//         <View style={styles.tableCol3}>
//           <Text style={styles.tableCellQuantity}>Picked?</Text>
//         </View>
//       </View>
//     {item.item_list.map((sub_item, sub_item_index)=>
//       <View key={sub_item_index} style={styles.tableRow}>
//         <View style={styles.tableCol1}>
//           <Text style={styles.tableCell}>{sub_item.name}</Text>
//         </View>
//         <View style={styles.tableCol2}>
//           <Text style={styles.tableCell}>{sub_item.product_format}</Text>
//         </View>
//         <View style={styles.tableCol3}>
//           <Text style={styles.tableCellQuantity}>{sub_item.quantity}</Text>
//         </View>
//         <View style={styles.tableCol3}>
//           <Text style={styles.tableCellQuantity}></Text>
//         </View>
//       </View>
//     )}
//       <View style={styles.tableRow}>
//         <View style={styles.tableColFooter1}>
//           <Text style={styles.tableCell}>Quantity Total</Text>
//         </View>
//         <View style={styles.tableCol3}>
//           <Text style={styles.tableCellQuantity}>{item.item_quantity_total}</Text>
//         </View>
//         <View style={styles.tableCol3}/>
//       </View>
//     </View>
//   </React.Fragment>
// )}
// </View>


// <div class="container-fluid">
//   <div class="pull-left">
//       <h3 class="font-montserrat all-caps hint-text">{{ business.name }}<br><small>{{ business.phone_primary }}</small></h3>
//   </div>
//   <div class="pull-right">
//       <h2 class="font-montserrat all-caps hint-text">{{ title  }} <span style="display:block;font-size:10px;">{{ bus_book_type.title }}</span></h2>
//   </div>
//   <div class="clearfix"></div>


// <div class="container-fluid">
//              <div class="pull-left">
//                  <h5 class="semi-bold m-t-0"><span style="display:block;font-size:10px;">Prepared For:</span>{{ bk_temp_proposal.bk_temp.full_name() }}</h5>
//                  <address>
//                    <strong>Event Date</strong><br>
//              {{ bk_temp_proposal.request_json.get('event_date', '') }}<br><br>
//                    <strong>Ready by Time</strong><br>
//              {{ bk_temp_proposal.request_json.get('ready_time', '') }}<br><br>
//                  </address>
//                  <address>
//                    <strong>OnSite Location</strong><br>
//              {{ bk_temp_proposal.request_json.get('name', 'Not Provided') }}<br>
//              {{ bk_temp_proposal.request_json.get('address', 'No Address') }}<br>
//              {{ bk_temp_proposal.request_json.get('city', 'No City') }}, {{ bk_temp_proposal.request_json.get('state', 'No State') }} {{ bk_temp_proposal.request_json.get('postal_code', 'No Zip') }}<br>
//                  </address>
//              </div>
//              <div class="pull-right">
//                <div>
//                  <div class="pull-left font-montserrat bold all-caps" style="margin-right:20px;">Proposal: </div>
//                  <div class="pull-right">{{ bk_temp_proposal.hash_id[:10] }}</div>
//                  <div class="clearfix"></div>
//                </div>
//                <div>
//                  <div class="pull-left font-montserrat bold all-caps" style="margin-right:20px;">Date: </div>
//                  <div class="pull-right">{{ bk_temp_proposal.last_modified.strftime('%m/%d/%Y') }}</div>
//                  <div class="clearfix"></div>
//                </div>
//              </div>
//              <div class="clearfix"></div>
//            </div>



// WEBPACK FOOTER //
// ./src/components/business/ModalPDF.js